import Container from "react-bootstrap/Container"
import { Parallax } from "react-parallax";
import LocationTwo from "../Global/HomeNav/LocationTwo";
import './blclocationcss/blclocationone.css';



//Blc_LocationOne for sm screen and calls on Blc_Location.
const Blc_LocationOne = (props) => {

    // const blcIndex = (index) => {
    //     props.valIndex(index);
    // }

    return (
        <Parallax bgImage="https://blcload.brac.net/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97/DJI_0862_00_01_36_25_Still006_edff10c80b_8885798a97.jpg" strength={100}>
            <Container className=" py-5 dark-overlay" fluid>
                <Container className="blcLocTwo">
                    <div className="galleryTitle">  <h4 className="locText">Explore 18 BRAC LEARNING CENTRES across Bangladesh!</h4></div>
                    <hr />
                    <LocationTwo navDataph={props.navData} />
                    {/* <LocationTwo valIndex={blcIndex} navDataph={props.navData} /> */}
                </Container>
            </Container>
        </Parallax>
    )
}


export default Blc_LocationOne;